import axios from 'axios';
import AppConfig from "../../../../AppConfig";

let URL = AppConfig.HOST_API();

export default {

    getMiejscowosci(idTr) {
        return axios({
            method: 'get',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/search/wariantTrasy/miejscowosci/' + idTr + AppConfig.V_LOG(),
        });
    },

    getTrasy() {
        return axios({
            method: 'get',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/search/trasy' + AppConfig.V_LOG(),
        });
    },

    getFaktura(idBm) {
        return axios({
            method: 'get',
            responseType: 'blob',
            headers: {
                'Authorization': 'Basic ' + btoa(JSON.parse(sessionStorage.getItem('loggedIn')).login + ':' + JSON.parse(sessionStorage.getItem('loggedIn')).pass),
                'Content-Type': 'application/pdf'
            },
            url: URL + 'client/api/auth/faktury/generujFakture/biletMiesieczny/' + idBm + AppConfig.V_LOG(),
        });
    },

    getBilety(idKl) {
        return axios({
            method: 'get',
            headers: {
                'Authorization': 'Basic ' + btoa(JSON.parse(sessionStorage.getItem('loggedIn')).login + ':' + JSON.parse(sessionStorage.getItem('loggedIn')).pass),
                'Content-Type': 'application/json'
            },
            url: URL + 'client/api/auth/bilety/miesieczne/byKlient/' + idKl + AppConfig.V_LOG(),
        });
    },

    getBiletyMiesieczne(idKa) {
        return axios({
            method: 'get',
            headers: {
                'Authorization': 'Basic ' + btoa(JSON.parse(sessionStorage.getItem('loggedIn')).login + ':' + JSON.parse(sessionStorage.getItem('loggedIn')).pass),
                'Content-Type': 'application/json'
            },
            url: URL + 'client/api/auth/bilety/miesieczne/byKarta/' + idKa + AppConfig.V_LOG(),
        });
    },

    getKarty(idKl) {
        return axios({
            method: 'get',
            headers: {
                'Authorization': 'Basic ' + btoa(JSON.parse(sessionStorage.getItem('loggedIn')).login + ':' + JSON.parse(sessionStorage.getItem('loggedIn')).pass),
                'Content-Type': 'application/json'
            },
            url: URL + 'client/api/auth/bilety/miesieczne/karty/byKlient/' + idKl + AppConfig.V_LOG(),
        });
    },

    getZnizkiMiesieczne(data, idMiOd, idMiDo, idTr, kierunek, okres) {
        return axios({
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/search/znizki/miesieczne' + AppConfig.V_LOG(),
            data: {
                "data": data,
                "idMiDo": idMiDo,
                "idMiOd": idMiOd,
                "idTr": idTr,
                "kierunek": kierunek,
                "okres": okres
            }
        });
    },

    postKarta(idKl, idMiDo, idMiOd, idTr, kierunek, okres, rodz, ekarta) {
        return axios({
            method: 'POST',
            headers: {
                'Authorization': 'Basic ' + btoa(JSON.parse(sessionStorage.getItem('loggedIn')).login + ':' + JSON.parse(sessionStorage.getItem('loggedIn')).pass),
                'Content-Type': 'application/json'
            },
            url: URL + 'client/api/auth/bilety/miesieczne/nowaKarta' + AppConfig.V_LOG(),
            data: {
                "idKl": idKl,
                "idMiDo": idMiDo,
                "idMiOd": idMiOd,
                "idTr": idTr,
                "kierunek": kierunek,
                "okres": okres,
                "rodz": rodz,
                "status": 'NOWA',
                "tylkoEkarta": ekarta
            }
        });
    },

    postMiesieczny(cena, karta, miesiac, rok, uwagi, idFi) {
        return axios({
            method: 'POST',
            headers: {
                'Authorization': 'Basic ' + btoa(JSON.parse(sessionStorage.getItem('loggedIn')).login + ':' + JSON.parse(sessionStorage.getItem('loggedIn')).pass),
                'Content-Type': 'application/json'
            },
            url: URL + 'client/api/auth/bilety/miesieczne' + AppConfig.V_LOG(),
            data: {
                "cena": cena,
                "fcmToken": localStorage.getItem('fcm-token') !== null && localStorage.getItem('fcm-token') !== undefined ? JSON.parse(localStorage.getItem('fcm-token')) : null,
                "formaPlatn:": "PR",
                "idKa": karta,
                "miesiac": miesiac,
                "rok": rok,
                "sprzedazMiejsce": "INTERNET",
                "uwagi": uwagi,
                "idFi": idFi
            }
        });
    },

    szukajFirmePoNipieAlboPoNazwie(string) {
        return axios({
                url: URL + 'client/api/auth/firmy/search?nazwaOrNip=' + string + AppConfig.V_LOG_SECOND_PARAM(),
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + btoa(JSON.parse(sessionStorage.getItem('loggedIn')).login + ':' + JSON.parse(sessionStorage.getItem('loggedIn')).pass),
                    'Content-Type': 'application/json'
                },
            }
        )
    },

    szukajFirmePoNipie(nip) {
        return axios({
                url: 'https://gw1.topsa.com.pl/gus/api/regon/json/daneSzukajByNip/' + nip,
                method: 'get',
            }
        )
    },

    addFirma(data) {
        return axios({
            method: 'post',
            url: URL + 'client/api/auth/firmy' + AppConfig.V_LOG(),
            data: JSON.stringify(data),
            headers: {
                'Authorization': 'Basic ' + btoa(JSON.parse(sessionStorage.getItem('loggedIn')).login + ':' + JSON.parse(sessionStorage.getItem('loggedIn')).pass),
                'Content-Type': 'application/json'
            },
        })
    },

    editFirma(id, data) {
        return axios(
            {
                url: URL + 'client/api/auth/firmy/' + id + AppConfig.V_LOG(),
                method: 'put',
                data: JSON.stringify(data),
                headers: {
                    'Authorization': 'Basic ' + btoa(JSON.parse(sessionStorage.getItem('loggedIn')).login + ':' + JSON.parse(sessionStorage.getItem('loggedIn')).pass),
                    'Content-Type': 'application/json'
                },
            }
        )
    },

    deleteFirma(id) {
        return axios({
                url: URL + 'client/api/auth/firmy/' + id + AppConfig.V_LOG(),
                method: 'delete',
                headers: {
                    'Authorization': 'Basic ' + btoa(JSON.parse(sessionStorage.getItem('loggedIn')).login + ':' + JSON.parse(sessionStorage.getItem('loggedIn')).pass),
                    'Content-Type': 'application/json'
                },
            }
        )
    },

    zapiszEvent(idKl, idEv) {
        return axios({
            method: 'POST',
            headers: {
                'Authorization': 'Basic ' + btoa(JSON.parse(sessionStorage.getItem('loggedIn')).login + ':' + JSON.parse(sessionStorage.getItem('loggedIn')).pass),
                'Content-Type': 'application/json'
            },
            url: AppConfig.HOST_API() + 'client/api/auth/event' + AppConfig.V_LOG(),
            data: {
                "idKl": idKl,
                "idStronaWpis": idEv
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/konto/panel/panelComponents/mojeBiletyComponents/BiletyMiesieczneService.js